import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=fba8356e&scoped=true&"
import script from "./productCenter.vue?vue&type=script&lang=js&"
export * from "./productCenter.vue?vue&type=script&lang=js&"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=fba8356e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba8356e",
  null
  
)

export default component.exports